import { useEffect } from 'react';
import { useState } from 'react';
import { Card, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { Redirect, useParams } from 'react-router';
import RequestSummary from '../../components/RequestSummary/RequestSummary';
import API from '../../services/api';
import { getStatus } from '../../services/requestService';
import './RequestViewer.css';

function RequestViewer() {
  const { id } = useParams();
  const [processedDate, setDate] = useState(null);
  const [request, setRequest] = useState(null);

  useEffect(() => {
    async function fetchData() {
      if (Number.parseInt(id)) {
        const result = await API.get(`request/${id}`);
        setRequest(result.data);

        if (result.data.processedDate[0] === '0') {
          setDate('Дата не встановлена!');
        } else {
          setDate(new Date(result.data.processedDate).toLocaleDateString());
        }
      }
    }

    fetchData();
  }, [id]);

  return !Number.parseInt(id) ? (
    <Redirect to="/request" />
  ) : (
    <Card>
      <Card.Body>
      <input name="action" onClick={() =>{window.history.back(); return false;}} className="requestViewerWrapper btn btn-secondary" type="submit" value="Назад"/>
        <Card.Title className="text-center">Запит №{id}</Card.Title>
        {!request ? (
          <h4>Завантаження...</h4>
        ) : (
          <>
            <RequestSummary request={request} />
            <FormGroup className='dateInputStyle'>
              <FormLabel>Дата обробки:</FormLabel>
              <FormControl id='warningDate' readOnly value={processedDate}></FormControl>
            </FormGroup>
            <FormGroup>
              <FormLabel>Статус:</FormLabel>
              <FormControl value={getStatus(request.status)} readOnly />
            </FormGroup>
            <FormGroup>
              <FormLabel>Відповідь:</FormLabel>
              <FormControl value={request.answer} as="textarea" rows={5} readOnly />
            </FormGroup>
          </>
        )}
      </Card.Body>
    </Card>
  );
}

export default RequestViewer;
